// extracted by mini-css-extract-plugin
module.exports = {"markerPin":"MarkerIcon_markerPin__1SRSu","icon":"MarkerIcon_icon__2XxO-","text":"MarkerIcon_text__PnfuX"};